import React from 'react';
import styled, { keyframes } from 'styled-components';

// Spinner animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Container for centering spinner
const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.fullScreen ? '100vh' : '300px'};
  width: 100%;
  background: ${props => props.fullScreen ? props.theme.colors.gray[50] : 'transparent'};
`;

// Spinner circle
const SpinnerCircle = styled.div`
  width: ${props => props.size === 'small' ? '24px' : props.size === 'large' ? '60px' : '40px'};
  height: ${props => props.size === 'small' ? '24px' : props.size === 'large' ? '60px' : '40px'};
  border: ${props => props.size === 'small' ? '3px' : '4px'} solid ${props => props.theme.colors.gray[200]};
  border-top-color: ${props => props.theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

// Optional loading text
const LoadingText = styled.p`
  margin-top: ${props => props.theme.spacing.lg};
  color: ${props => props.theme.colors.gray[600]};
  font-size: ${props => props.theme.fontSizes.lg};
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const LoadingSpinner = ({ 
  fullScreen = false, 
  size = 'medium', 
  text = null 
}) => {
  return (
    <SpinnerContainer fullScreen={fullScreen}>
      <div style={{ textAlign: 'center' }}>
        <SpinnerCircle size={size} />
        {text && <LoadingText>{text}</LoadingText>}
      </div>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
